module.exports = __webpack_public_path__ + "static/media/tag1.e103a239.svg";